(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scatter-reveal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Target positions, read from the approved layout (percent of section width/height).
    var NUMBERS = [
      { text: '(1)', x: 46.9, y: 23.7, tone: 'light', size: '1.7rem' },
      { text: '(10)', x: 77.1, y: 23.7, tone: 'xlight', size: '1.3rem' },
      { text: '(7)', x: 16.7, y: 30.5, tone: 'dark', size: '1.5rem' },
      { text: '(03)', x: 65.1, y: 49.0, tone: 'dark', size: '1.9rem' },
      { text: '(04)', x: 46.4, y: 61.5, tone: 'light', size: '1.3rem' },
      { text: '(9)', x: 12.5, y: 67.0, tone: 'dark', size: '2.1rem' },
      { text: '(3)', x: 17.5, y: 73.5, tone: 'xlight', size: '3.4rem' },
      { text: '(2026)', x: 83.0, y: 85.0, tone: 'dark', size: '1.9rem' }
    ];

    var CENTER_X = 49.5;
    var CENTER_Y = 45.1;

    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    function initInstance(root) {
      var wrapper = root.querySelector('.scatter-reveal__wrapper');
      var scatter = root.querySelector('[data-scatter]');
      var hint = root.querySelector('[data-hint]');
      if (!wrapper || !scatter) return;

      var nums = NUMBERS.map(function (n) {
        var el = document.createElement('div');
        el.className = 'scatter-reveal__num';
        el.dataset.tone = n.tone;
        el.style.fontSize = n.size;
        el.style.left = CENTER_X + '%';
        el.style.top = CENTER_Y + '%';
        el.style.transform = 'translate(-50%,-50%) scale(0.4)';
        el.style.opacity = '0';
        el.textContent = n.text;
        el.dataset.tx = n.x;
        el.dataset.ty = n.y;
        scatter.appendChild(el);
        return el;
      });

      function update() {
        var total = wrapper.offsetHeight - window.innerHeight;
        var rect = wrapper.getBoundingClientRect();
        var progress = total > 0 ? -rect.top / total : 0;
        progress = Math.min(Math.max(progress, 0), 1);
        var eased = easeOutCubic(progress);

        nums.forEach(function (el) {
          var tx = parseFloat(el.dataset.tx);
          var ty = parseFloat(el.dataset.ty);
          var curX = CENTER_X + (tx - CENTER_X) * eased;
          var curY = CENTER_Y + (ty - CENTER_Y) * eased;
          var scale = 0.4 + 0.6 * eased;
          el.style.left = curX + '%';
          el.style.top = curY + '%';
          el.style.opacity = eased;
          el.style.transform = 'translate(-50%,-50%) scale(' + scale + ')';
        });

        if (hint) hint.style.setProperty('--hint-opacity', progress > 0.05 ? 0 : 1);
      }

      var ticking = false;
      window.addEventListener(
        'scroll',
        function () {
          if (!ticking) {
            requestAnimationFrame(function () {
              update();
              ticking = false;
            });
            ticking = true;
          }
        },
        { passive: true }
      );
      window.addEventListener('resize', update);
      update();
    }

    document.querySelectorAll('[data-scatter-reveal]').forEach(initInstance);
  })();

  } catch(e) { console.error(e); }
})();
})();
